var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from 'react';
import AppMessage from './appMessage';
import pwResetHttpService from '../services/pw-reset-http.service';
import SubmitButton from "./SubmitButton";
import { withTranslation, Trans } from "react-i18next";
var UserNameForm = /** @class */ (function (_super) {
    __extends(UserNameForm, _super);
    function UserNameForm(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (event) {
            _this.setState({
                user: {
                    user: event.currentTarget.value
                }
            });
        };
        _this.handleSubmit = function (event) {
            var _a, _b;
            event.preventDefault();
            if (((_a = _this.state) === null || _a === void 0 ? void 0 : _a.user.user) === '') {
                _this.setState({ hasError: true });
                return;
            }
            _this.setState({ hasError: false, isLoading: true, disabled: true });
            pwResetHttpService.sendPw((_b = _this.state) === null || _b === void 0 ? void 0 : _b.user).then(function (_) {
                _this.setState({
                    message: 'Die Nachricht mit dem Link zum Neusetzen des Passworts ist auf dem Weg',
                    hasError: false, done: true
                });
            }).catch(function (_) {
                _this.setState({
                    message: 'Die Nachricht mit dem Link zum Neusetzen des Passworts konnte nicht verschickt werden',
                    hasError: true
                });
            }).finally(function () { return _this.setState({ isLoading: false, disabled: false }); });
        };
        _this.state = {
            hasError: false,
            isLoading: false,
            disabled: false,
            done: false,
            message: '',
            user: {
                user: ''
            }
        };
        return _this;
    }
    UserNameForm.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        return (React.createElement(React.Fragment, null,
            React.createElement(AppMessage, { message: (_a = this.state) === null || _a === void 0 ? void 0 : _a.message, success: !((_b = this.state) === null || _b === void 0 ? void 0 : _b.hasError) }),
            React.createElement("div", { className: 'row' },
                React.createElement("div", { className: 'small-12 large-10 large-centered columns helper-margin-top-l', hidden: (_c = this.state) === null || _c === void 0 ? void 0 : _c.done },
                    React.createElement("h1", null,
                        React.createElement(Trans, null, "Kontowiederherstellung")),
                    React.createElement("p", null,
                        React.createElement(Trans, null, "Bitte geben Sie Ihre LMU-Benutzerkennung ein. Wir senden Ihnen eine E-Mail an Ihre Wiederherstellungsmailadresse mit einem Link, mit dem Sie ein neues Passwort setzen k\u00F6nnen. Bitte pr\u00FCfen Sie auch Ihren SPAM-Ordner.")),
                    React.createElement("p", null,
                        React.createElement(Trans, { i18nKey: "it-servicedesk" },
                            "Weitere Infos zur Kontowiederherstellung (",
                            React.createElement("a", { target: "_blank", href: "https://www.lmu.de/de/die-lmu/struktur/zentrale-universitaetsverwaltung/informations-und-kommunikationstechnik-dezernat-vi/it-servicedesk/zentrale-it-angebote/lmu-benutzerkennung/" }, "IT-Servicedesk"),
                            ")")),
                    React.createElement("div", { className: 'row ' },
                        React.createElement("div", { className: 'small-12 large-8 columns' },
                            React.createElement("form", { noValidate: true, onSubmit: this.handleSubmit },
                                React.createElement("fieldset", { className: 'helper-no-margin-top', disabled: (_d = this.state) === null || _d === void 0 ? void 0 : _d.disabled },
                                    React.createElement("div", { className: 'row' },
                                        React.createElement("div", { className: 'small-6 medium-3 columns' },
                                            React.createElement("label", { htmlFor: 'username' },
                                                React.createElement(Trans, null, "Benutzername"),
                                                ":")),
                                        React.createElement("div", { className: 'small-12 medium-6 columns end' },
                                            React.createElement("input", { type: 'text', id: 'username', name: 'username', value: (_f = (_e = this.state) === null || _e === void 0 ? void 0 : _e.user) === null || _f === void 0 ? void 0 : _f.user, onChange: this.handleChange, required: true }),
                                            React.createElement("small", { className: "error " + (((_g = this.state) === null || _g === void 0 ? void 0 : _g.hasError) ? 'show' : 'hide') },
                                                React.createElement(Trans, null, "Ein Benutzername wird ben\u00F6tigt")))),
                                    React.createElement("div", { className: 'row helper-margin-bottom-m' },
                                        React.createElement("div", { className: 'small-12 medium-6 end columns medium-offset-3' },
                                            React.createElement(SubmitButton, { isLoading: (_h = this.state) === null || _h === void 0 ? void 0 : _h.isLoading, disabled: (_j = this.state) === null || _j === void 0 ? void 0 : _j.disabled })))))))))));
    };
    return UserNameForm;
}(Component));
export default withTranslation()(UserNameForm);
